// This file is generated by a script. Do not edit this file directly.
export var colors = {
  blue: {
    700: '#053299',
    500: '#0C41BB',
    400: '#053299',
    200: '#92A9E0',
    100: '#E6F0FF'
  },
  green: {
    500: '#115B3B',
    100: '#DFFFEB'
  },
  red: {
    500: '#991A00',
    100: '#FFEDE8'
  },
  orange: {
    500: '#863805',
    100: '#FEF6D0'
  },
  purple: {
    500: '#4B3AA3',
    100: '#F1EEFF'
  },
  gray: {
    500: '#9B9FA3'
  }
};
export var categoricalColors = {
  gray: '#b8bfcb',
  violet: '#a988e6',
  rose: '#e9728b',
  amber: '#e7b04a',
  teal: '#56c6be',
  cyan: '#77b6e3'
};
